// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ry3Ki","right":"styles_right__Sysw7"};